import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  fetchAndSetTaxVerificationItems,
  fetchAndSetEmployeedata
} from "../network/actions";
import { makeOptions, makeSelectedOptions } from "app/common/reducers/filters";
import { setSortOrder, clearSortOrder } from "app/common/reducers/sortOrder";
import { TaxVerification } from "component-library/payroll-dashboard/wagetaxvalidation";
import { NoPayrollChecklistAlertsToCorrent } from "component-library/payroll-dashboard/address-verification";

class TaxVerificationContainer extends Component {
  state = {};

  componentDidMount() {
    const {
      fetchAndSetTaxVerificationItems,
      match: {
        params: { payrollId }
      }
    } = this.props;

    fetchAndSetTaxVerificationItems(parseInt(payrollId, 10));
  }

  componentWillUnmount() {
    this.props.clearSortOrder();
  }

  changeSortOrder = (field, sortOrder) => {
    const {
      fetchAndSetTaxVerificationItems,
      match: {
        params: { payrollId }
      },
      setSortOrder
    } = this.props;

    setSortOrder(field, sortOrder);
    fetchAndSetTaxVerificationItems(parseInt(payrollId, 10));
    setTimeout(
      function() {
        this.searchPostsUnapprovedPto();
      }.bind(this),
      10
    );
  };

  makeOnSelect = name => (option, selected) => {
    this.props.selectOption(name, option, selected);
  };

  makeSelectAll = name => selected => {
    this.props.selectAll(name, selected);
  };

  editMinimumWagesAlerts = (Id, data) => {
    const { fetchAndSetEmployeedata } = this.props;
    fetchAndSetEmployeedata(Id);
    this.setState({
      openEditModal: true
    });
  };

  modalBody = () => {
    //const { employeeData } = this.props.payrollTypeData.EmployeeData;
    return (
      <div className="modal-body-container">
        <div className="modal-body-header">Edit Tax Verification</div>
        <div className="modal-body-content" />
      </div>
    );
  };

  closeFooterButton = () => {
    const modalButton = [
      {
        label: "Update Tax Verification",
        buttonType: "secondary-button",
        onClick: this.closeModal
      },
      {
        label: "Cancel",
        buttonType: "secondary-link-button",
        onClick: this.closeModal
      }
    ];

    return modalButton;
  };

  closeModal = () => {
    this.setState({
      openEditModal: false
    });
  };

  render() {
    const { redirectToChecklist } = this.props;
    const dataCount = this.props.payrollTypeData.TaxVerification.DataCount;
    return (
      <div>
        {dataCount > 0 ? (
          <div>
            <TaxVerification
              data={this.props.payrollTypeData.TaxVerification.Data}
              hr
              redirectToChecklist={redirectToChecklist}
            />
          </div>
        ) : (
          <NoPayrollChecklistAlertsToCorrent checklistAlert="tax verifications" />
        )}
      </div>
    );
  }
}

const stateToProps = state => ({
  payrollTypeData: state.payrollDashboard.payrollTypeData,
  filterData: makeOptions(state.common.filters),
  selectedOptions: makeSelectedOptions(state.common.filters),
  sortOrder: state.common.sortOrder
});

const actionCreators = {
  fetchAndSetTaxVerificationItems,
  fetchAndSetEmployeedata,
  setSortOrder,
  clearSortOrder
};

export default withRouter(
  connect(stateToProps, actionCreators)(TaxVerificationContainer)
);
